import loginService from './loginService';
import menuService from './menuService';
import cacheService from './cacheService';

export default {
  async login(userId, password) {
    try {
      return await loginService.login(userId, password);
    } catch (err) {
      console.error(err);
    }
  },
  async loginNewEpTray(userInfo, key) {
    try {
      return await loginService.loginNewEpTray(userInfo, key);
    } catch (err) {
      console.error(err);
    }
  },
  logout(errCode) {
    return loginService.logout(errCode);
  },
  async getMenus(forceRemote = false) {
    return menuService.getMenus(forceRemote);
  },
  clearCache() {
    cacheService.clearCache();
  },
};

export { default as signupService } from './signupService';
export { default as syslinkService } from './syslinkService';
export { default as excelCommService } from './excelCommService';



// WEBPACK FOOTER //
// ./src/service/index.js